import React, { useContext, useEffect, useState } from "react";
import { apiGet, apiPost } from "../../utils/apiFetch"; // Removed apiPost if not used elsewhere
import apiPath from "../../utils/apiPath";
import helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { FiDownload } from "react-icons/fi";
import { BsArrowUpShort } from "react-icons/bs";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import Pagination from "../Pagination";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import OSearch from "components/reusable/OSearch";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import CustomSelect from "components/reusable/CustomSelect";
import { statusOptions } from "utils/constants";
import OButton from "components/reusable/OButton";
import * as XLSX from "xlsx"; // Import xlsx library

function SubscriptionStatistics() {
  const { t } = useTranslation();
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const { logoutUser, updatePageName } = useContext(AuthContext);
  const [subscriptionStatistics, setSubscriptionStatistics] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isDelete, setIsDelete] = useState(false);
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);
  const [filterData, setFilterData] = useState({
    category: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });

  const getAllSubscription = async (payload) => {
    try {
      const { category, searchKey, startDate, endDate } = filterData;
      if (payload?.deletePage) {
        payload = {
          page,
          pageSize,
          status: category,
          sortBy: sort.sortBy,
          sortType: sort.sortType,
          type: "subscription",
          keyword: searchKey,
          startDate: helpers?.ternaryCondition(
            startDate,
            dayjs(startDate).format('YYYY-MM-DD'),
            null
          ),
          endDate: helpers?.ternaryCondition(
            endDate,
            dayjs(endDate).format('YYYY-MM-DD'),
            null
          )
        };
        if (subscriptionStatistics?.length >= 1) {
          setPage(page - 1);
          setIsDelete(true);
          setPaginationObj({ ...paginationObj, page: page - 1 });
        }
      } else {
        payload = {
          page,
          pageSize,
          status: category,
          sortBy: sort.sortBy,
          sortType: sort.sortType,
          type: "subscription",
          keyword: searchKey?.trim(),
          startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
          endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
        };
        setIsDelete(false);
      }
      const path = apiPath.getSubscription;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setSubscriptionStatistics(response?.docs);
        setPaginationObj({
          ...paginationObj,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log(
        "error in get all subscription statistics list==>>>>",
        error.message
      );
      if (error.response?.status === 401 || error.response?.status === 409) {
        logoutUser();
      }
    }
  };

  useEffect(() => {
    getAllSubscription();
  }, [page, sort, filterData]);

  // --- NEW EXPORT FUNCTION USING XLSX ---
  const handleDownloadReport = () => {
    try {
      if (!subscriptionStatistics || subscriptionStatistics.length === 0) {
        // You can replace this with your toast notification if you have one
        alert("No data available to export"); 
        return;
      }

      // Map the data to format the headers nicely for the Excel sheet
      const dataToExport = subscriptionStatistics.map((item, index) => ({
        "Sr No": index + 1 + 10 * (page - 1),
        "Subscription ID": item?._id,
        "Subscription Name": item?.name,
        "Amount": `$${item?.amount}`,
        "Total Purchase Count": item?.purchasedCount,
        "Duration (In days)": item?.duration,
        "Created Date": dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A"),
        "Status": startCase(item?.status)
      }));

      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      // Create a workbook
      const workbook = XLSX.utils.book_new();
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Subscriptions");
      
      // Generate filename with current date
      const fileName = `Subscription_Statistics_${dayjs().format("YYYY-MM-DD")}.xlsx`;
      
      // Trigger download
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log("error in exporting:", error);
    }
  };

  useEffect(() => {
    updatePageName(t("SUBSCRIPTION_STATISTICS"));
  }, []);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const statusPage = (e) => {
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true,
    });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      category: "",
      searchKey: "",
      isReset: true,
      isFilter: false,
      setStatus: "",
      startDate: "",
      endDate: "",
    });
    setPage(1);
    setSearchTerm("");
  };

  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            {/* Added onSubmit={(e) => e.preventDefault()} to stop form submission on enter if you don't want it */}
            <form onSubmit={(e) => e.preventDefault()} className="2xl:flex gap-2 border-b border-b-[#E3E3E3] px-4 py-3">
              <div className="flex-wrap  items-center mb-2 col-span-2 flex 2xl:mb-0">
                <div className="flex lg:pt-0 pt-3 flex-wrap items-center ">
                  <div className="relative items-center mb-3 flex ">
                    <OSearch
                      placeholder={t("KEYWORD")}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    setIsReset={setFilterData}
                    isReset={filterData?.isReset}
                  />
                  <CustomSelect
                    onChange={statusPage}
                    options={statusOptions}
                    placeholder="O_ALL"
                    id="category"
                    name="category"
                    value={filterData.category}
                    t={t}
                  />

                  <OButton
                    label="Reset"
                    extraClasses="mb-3 ml-3"
                    type="button"
                    onClick={handleReset}
                    style={{ borderRadius: "0.5rem" }}
                  />
                </div>
              </div>
              <div className="justify-end px-4 ms-auto flex items-center  mb-3">
                <button
                  title={t("EXPORT")}
                  type="button" /* CRITICAL FIX: Stops form validation from firing */
                  className="bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap"
                  onClick={handleDownloadReport}
                >
                  <FiDownload className="mr-3" />
                  {t("EXPORT")}
                </button>
              </div>
            </form>
            <div className="p-3">
              <div className="overflow-x-auto relative rounded-lg border">
                <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
                  <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <TableHeaderCell text={t("SR_NO")} />
                      <TableHeaderCell text={t("SUBSCRIPTION_ID")} />
                      <TableHeaderCell text={t("SUBSCRIPTION_NAME")} />
                      <TableHeaderCell text={t("SUBSCRIPTION_AMOUNT")} />
                      <TableHeaderCell text={t("TOTAL_PURCHASE_COUNT")} />
                      <th scope="col" className="py-3 px-6">
                        {t("DURATION")} (In days)
                      </th>
                      <th
                        className="cursor-pointer px-6  py-3 "
                        scope="col"
                        onClick={() => {
                          const newSortType =
                            sort.sortType === "asc" ? "desc" : "asc";
                          setSort({
                            sortBy: "createdAt",
                            sortType: newSortType,
                          });
                        }}
                      >
                        <div className="justify-start flex">
                          <span>{t("CREATED_DATE")}</span>
                          <span>
                            {sort.sortBy === "createdAt" && (
                              <BsArrowUpShort
                                className={`w-4 h-4 ${
                                  sort.sortType === "asc" ? "" : "rotate-180"
                                }`}
                              />
                            )}
                          </span>
                        </div>
                      </th>

                      <th scope="col" className="py-3 px-6 text-center">
                        {t("O_STATUS")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscriptionStatistics &&
                      subscriptionStatistics?.map((item, i) => (
                        <tr
                          key={i}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                        >
                          <th
                            scope="row"
                            className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                          >
                            {i + 1 + 10 * (page - 1)}
                          </th>
                          <td className="py-4 px-6 border-r text-gray-900">
                            {item?._id}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900">
                            {item?.name}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900">
                            ${item?.amount}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900">
                            {item?.purchasedCount}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900">
                            {item?.duration}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900 ">
                            {dayjs(item?.createdAt).format(
                              "MM-DD-YYYY hh:mm A"
                            )}
                          </td>
                          <td className="py-4 px-6 border-r text-gray-900 text-center">
                            {startCase(item?.status)}
                          </td>
                        </tr>
                      ))}
                    {isEmpty(subscriptionStatistics) ? (
                      <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                        <td className="py-4 px-6 border-r" colSpan={10}>
                          {t("O_NO_RECORD_FOUND")}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionStatistics;